export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR';
export const CLOSE_ALL_SNACKBAR = 'CLOSE_ALL_SNACKBAR';
export const REMOVE_ALL_SNACKBAR = 'REMOVE_ALL_SNACKBAR';